import { css } from "@emotion/react";
import appConfig from "constants/appConfig";
import React, { useEffect } from "react";

import { ContentsLayout } from "../../styles";

type Props = Record<string, never>;

const FanyIdCallback: React.FC<Props> = (_props) => {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const otpTd = urlParams.get("otp_td");
    const ao = urlParams.get("ao");

    const redirectUrl = new URL(
      `${appConfig.backendApiUrl}/auth/providers/fanyid/callback`
    );
    if (otpTd) redirectUrl.searchParams.append("otp_td", otpTd);
    if (ao) redirectUrl.searchParams.append("ao", ao);
    redirectUrl.searchParams.append("origin", window.location.origin);

    window.location.href = redirectUrl.toString();
  }, []);

  return (
    <div id="contents">
      <ContentsLayout
        css={css`
          min-height: calc(100vh - 601px);
          padding: 40px;
          @media screen and (min-width: 768px) {
            min-height: calc(100vh - 386px);
          }
        `}
      >
        <h2>FANY ID Callback</h2>
      </ContentsLayout>
    </div>
  );
};

export default FanyIdCallback;
